import {ObjectModelPermissionType} from "~/enums/objectModelPermissionType";

export enum objectModelBuiltinPermission {
  ConnectOrSeverRecordHolder = 'ConnectOrSeverRecordHolder'
}

export const BuiltinPermissionObjectMap = {
  [objectModelBuiltinPermission.ConnectOrSeverRecordHolder]: {client_id: objectModelBuiltinPermission.ConnectOrSeverRecordHolder, permission_type: ObjectModelPermissionType.Relationship, displayName: 'ObjectModelRelation'},
};